// extracted by mini-css-extract-plugin
export default {"badge":"styles_badge__w1Du9","HIGH":"styles_HIGH__oG6Cr","STANDARD":"styles_STANDARD__ydrvB","MEDIUM":"styles_MEDIUM__p63TF","LOW":"styles_LOW__7kmEZ"};